import { filtersHelper } from '@/utils';

export const documentCategoryModel = (data = {}) => ({
    uuid: data.uuid || '',
    name: data.name || '',
    description: data.description || '',
    isActive: data.is_active == null ? true : data.is_active === true || Number(data.is_active) === 1,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
});
